'use strict';var makeClass = require('../utils/make-class');var _require = 
require('./uint');var UInt = _require.UInt;

var UInt8 = makeClass({ 
  inherits: UInt, 
  statics: { width: 1 } });


module.exports = { 
  UInt8: UInt8 };


//////////////////
// WEBPACK FOOTER
// ./node_modules/ripple-hashes/node_modules/ripple-binary-codec/distrib/npm/types/uint-8.js
// module id = pedG
// module chunks = 0